import { render, staticRenderFns } from "./LandingSection.vue?vue&type=template&id=06f94b2c&scoped=true&"
import script from "./LandingSection.vue?vue&type=script&lang=js&"
export * from "./LandingSection.vue?vue&type=script&lang=js&"
import style0 from "./LandingSection.vue?vue&type=style&index=0&id=06f94b2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f94b2c",
  null
  
)

export default component.exports